import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as _ from 'lodash';

import { allFetchersMap } from '../../../../../shared/fetchers';
import * as IssuesV2Store from '../../../../redux/issuesV2';
import type { SelectOption } from '../../../../types';
import { selectOptionFactory } from '../../../../utils';

// include both fossa-specific and third-party package managers as dropdown options
const PACKAGE_MANAGER_DROPDOWN_OPTIONS: Array<SelectOption<string>> = _.sortBy(
  Object.entries(allFetchersMap).map(([value, label]) => selectOptionFactory(value, label)),
  elem => elem.label,
);

/**
 * Fetches the list of relevant package managers whenever the current category, status, or scope changes.
 */
const usePackageManagers = (): { isLoading: boolean; packageManagers: Array<SelectOption<string>>; } => {
  const dispatch = useDispatch();

  const { isLoading, value: packageManagers } = useSelector(IssuesV2Store.selectors.getPackageManagers);
  const category = useSelector(IssuesV2Store.selectors.getIssueCategory);
  const status = useSelector(IssuesV2Store.selectors.getStatus);
  const scope = useSelector(IssuesV2Store.selectors.getScope);

  // reset the current selection and fetch updated package managers whenever
  // the current category, status, or scope changes
  useEffect(() => {
    dispatch(IssuesV2Store.actions.setPackageManagersFilter([]));
    dispatch(IssuesV2Store.actions.fetchPackageManagers(category, status, scope));
  }, [dispatch, category, status, scope]);

  // filter dropdown options down to just the available package managers
  const options = PACKAGE_MANAGER_DROPDOWN_OPTIONS.filter((option) => packageManagers?.includes(option.value));

  return {
    isLoading,
    packageManagers: options,
  };
};

export default usePackageManagers;
